exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Ao0zr7dHvI7atQ_y820Jc{display:none}._3jO_fYZkETihBbd1wAnkAS{width:100%;height:calc(100% - 80px)}._1kgyZKCq3JmMt853PY73hP{height:calc(100% - 70px)}.sFXu6QbY7Ky_o7XUmLrSp{display:block;top:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.sFXu6QbY7Ky_o7XUmLrSp iframe{max-height:100%}._2ZwJR2pdaqqXnj3Xg_FBSY{display:none}", ""]);

// exports
exports.locals = {
	"divContainer": "_1Ao0zr7dHvI7atQ_y820Jc",
	"extensionContainer": "_3jO_fYZkETihBbd1wAnkAS",
	"extensionContainerCalendar": "_1kgyZKCq3JmMt853PY73hP",
	"extensionHost": "sFXu6QbY7Ky_o7XUmLrSp",
	"hide": "_2ZwJR2pdaqqXnj3Xg_FBSY"
};